import React, { useEffect, useState } from 'react';
import Sidebar from '../homepage/components/Sidebar';
import TopHeader from '../homepage/components/TopHeader';
import { Row, Col } from "react-bootstrap"
import Card from './components/card';
import FormCard from '../homepage/components/FormCard'
import { useQuery } from 'react-query';
import getProjects from '../../api/getProjects';
import { useParams } from 'react-router';
import getProjectDashboard from '../../api/getProjectDashboard';
import { useDispatch, useSelector } from 'react-redux';
import { resetForm } from '../../redux/formsSlice';
import { resetJoin } from '../../redux/joinsSlice';
import { resetColumns } from '../../redux/columnsSlice';
import { resetFilters } from '../../redux/filtersSlice';
import { toggleReloadFilters } from '../../redux/selectedProjectSlice';
import { updateTitle } from '../../redux/updatePageHeadeSlice';
import BootstrapTable from 'react-bootstrap-table-next';
import getFormDetails from '../../api/getFormDetails';
import Loader from '../../pages/utilities/loader';

const ProjectsPage = () => {
    const [projectData, setProjectData] = useState([])
    const dispatch = useDispatch()
    const selectedProject = useSelector(state => state.selectedProject);

    const { isLoading, data } = useQuery('getFormDetails', () => getFormDetails(selectedProject?.name));
    const { project_name } = useParams();
    const { isLoading: isLoadingDashboard, data: dataDashboard } = useQuery("getProjectDashboard" + project_name, () => getProjectDashboard(project_name))

    useEffect(() => {
        dispatch(resetForm())
        dispatch(resetJoin())
        dispatch(resetColumns())
        dispatch(resetFilters())
        dispatch(toggleReloadFilters(true))
        dispatch(updateTitle(selectedProject?.name))
    }, [])

    useEffect(() => {
        if (dataDashboard?.success) {
            const tempGlobal = []
            Object.keys(dataDashboard?.data).map(formName => {
                tempGlobal.push({ ...dataDashboard?.data[formName], form_name: formName })
            })
            setProjectData([...tempGlobal])
        }
    }, [dataDashboard?.data])


    // const { isLoading, data } = useQuery("getProjects", getProjects)

    if (isLoading || isLoadingDashboard) {
        return <><Loader /></>
    }
    // const project = data.data.find((project) => project.project_name === project_name);
    // const { forms } = project;

    // const validatedForms = forms.filter(el => el.form_status === "VALIDATED");
    // const { number_of_contributors, number_of_research_key, number_of_forms, number_of_documents } = dataDashboard.data

    // const documentsLength = number_of_documents && Object.values(number_of_documents).reduce((acc, cur) => acc + cur);

    const projectColumns = [
        {
            dataField: 'form_name',
            text: 'Formulaires'
        },
        {
            dataField: 'archives_count',
            text: 'Archives'
        },
        {
            dataField: 'recycled_count',
            text: 'Documents générés'
        },
        {
            dataField: 'new_docs_count',
            text: 'Insertion de documents'
        },
        {
            dataField: 'drafts_count',
            text: 'Brouillons'
        },
        {
            dataField: 'columns_count',
            text: 'Colonnes'
        },
        {
            dataField: 'research_keys_count',
            text: 'Clés de Recherche'
        }
    ];

    return (
        <>
            <div >
                <h3 className="heading">SYNTHESE PROJET</h3>
                <BootstrapTable keyField='id' data={projectData} columns={projectColumns} hover />
                {/* <Row>
                    <Col lg="3" md="12">
                        <Card formsCount={number_of_forms} type="Number of forms" bg="rgb(106, 117, 148)" />
                    </Col>
                    <Col lg="3" md="12">
                        <Card formsCount={number_of_research_key} type="Number of research keys" bg="#A63247" />
                    </Col>
                    <Col lg="3" md="12">
                        <Card formsCount={documentsLength} type="Number of documents by form" bg="#3F6274" />
                    </Col>
                    <Col lg="3" md="12">
                        <Card formsCount={number_of_contributors} type="Number of contributors" bg="#590202" />
                    </Col>
                </Row> */}
            </div>
            <div className="section-margin">
                <h3 className="heading">FORMULAIRES</h3>
                <Row>
                    {data?.map(({ form_name, form_last_modification_date, description, form_associated_project }) =>
                        // <Col xl={1} lg={3} md={4}  >
                        <div className='d-grid'>
                            <FormCard
                                formName={form_name}
                                lastUpdated={form_last_modification_date}
                                description={description}
                                project_name={form_associated_project}
                            />
                        </div>
                        // </Col>
                    )}

                    {!data?.length && <p className="text-gray-500 text-lg mx-auto">No validated forms</p>}
                </Row>
            </div>
        </>
    );
}

export default ProjectsPage;
